import IconMap from "@components/icons/Map.vue";
import IconTrophy from "@components/icons/Trophy.vue";
import IconFlame from "@components/icons/Flame.vue";
import IconCheckmark from "@components/icons/Checkmark.vue";
import IconSettings from "@components/icons/Settings.vue";
import IconSpeedIcon from "@components/icons/SpeedIcon.vue";

export const navLinks = [
    { label: "Explore", name: "explore", icon: IconMap },
    { label: "Achievements", name: "achievements", icon: IconTrophy },
    { label: "Trivia", name: "trivia", icon: IconFlame },
    { label: "Vote", name: "vote", icon: IconCheckmark },
    { label: "Settings", name: "settings", icon: IconSettings },
    { label: "Meet Speed", name: "help", icon: IconSpeedIcon },
];
